<template>
    <div class="error">
        <div class="wrapper full">

            <div class="title">{{ $t('error.title') }}</div>
            <img class="status-icon" src="../../assets/warning.svg"/>
            <div class="action">{{ $t('error.callToAction') }}</div>
        </div>

        <div class="wrapper">
            <p>
                {{ $t('error.support') }}
                <template v-if="err">
                    <span style="font-size: .75em;">({{err}})</span>
                </template>
            </p>

        </div>
    </div>
</template>

<script>
  export default {
    name: 'Error',
    props: ['err']
  };
</script>

<style scoped lang="scss">
    .wrapper {
        font-size: 1.25em;
    }

    .error {
        background: $brand-warning;
        color: #FFF;
    }
</style>